import { ready } from 'brei-project-utils';

import { plugin } from './lib/plugin';

import { accordion } from './modules/accordion';
import { announcement } from './modules/announcement';
import { form } from './modules/form';
import { gallery } from './modules/gallery';
import { header } from './modules/header';
import { mark } from './modules/mark';
import { masthead } from './modules/masthead';
import { storytelling } from './modules/storytelling';
import { table } from './modules/table';
import { takeover } from './modules/takeover';
import { Tooltip } from './modules/tooltip';
import { video } from './modules/video';

// Example of importing a custom module
// import { primaryNav } from './modules/primaryNav';

const main = {

	elem: {
		$textTooltip: $('.text-tooltip'),
		$tooltip: $('.tooltip')	
	},

	init() {
		plugin('Tooltip', Tooltip);

		announcement.init();
		takeover.init();

		mark.init();

		header.init();
		masthead.init();
		
		accordion.init();
		form.init();
		storytelling.init();
		table.init();
		video.init();

		this.bindUIActions();
	},

	bindUIActions() {
		this.elem.$tooltip.Tooltip({ type: 'button' });

		this.elem.$textTooltip.Tooltip({
			type: 'text',
			after(target) {
				$(target).toggleClass('text-tooltip--is-active');
			}
		});
	}

};

// Fire items on ready when all that is necessary is the complete DOM

ready(function () {
	main.init();
});

// Fire init on load when images and assets may affect page layout

window.addEventListener('load', function() {
	gallery.init();
});
